import { Box, CircularProgress, Grid } from '@material-ui/core';
import InputField from 'components/InputField';
import messages from 'containers/PasswordRecoveryPages/InsertIdentifiant/messages';
import { StyledOrangeButton } from 'containers/PasswordRecoveryPages/InsertIdentifiant/styles';
import validationSchema from 'containers/PasswordRecoveryPages/InsertIdentifiant/validationOrganismeSchema';
import HealthInsuranceFields from 'containers/SignupPages/PersonalInfo/HealthInsuranceFields';
import { FormikProps, withFormik } from 'formik';
import { EVENT_CATEGORIES } from 'helpers/GATracking';
import GaClickHOC from 'helpers/GATracking/GaClickHOC';
import { translate } from 'helpers/intl';
import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';

const InsertOrganismeIdForm = (
  props: {
    loader?: boolean;
    errorMessage?: string;
  } & FormikProps<FormValues>,
) => {
  const {
    values,
    errors,
    handleSubmit,
    handleChange,
    loader,
    setFieldValue,
    touched,
    handleBlur,
  } = props;

  return (
    <form onSubmit={handleSubmit}>
      <Box paddingY={2} paddingX={[2, 4, 8]}>
        <Box marginY={3}>
          <HealthInsuranceFields
            setFieldValue={setFieldValue}
            handleChange={handleChange}
            organization={values.organization}
            membershipNumber={values.membershipNumber}
            cin={values.cin}
            touched={touched}
            drpp={values.drpp}
            errors={errors}
            displayCin
          />
        </Box>

        <Grid item>
          <InputField
            name="birthday"
            label={translate({ ...messages.birthday }, props)}
            placeholder={translate({ ...messages.birthday }, props)}
            value={values.birthday}
            type="date"
            error={touched.birthday && errors.birthday}
            helperText={touched.birthday && errors.birthday}
            handleChange={handleChange}
            handleBlur={handleBlur}
            InputLabelProps={{
              shrink: true,
            }}
            InputProps={{
              inputProps: { max: '9999-12-30' },
            }}
          />
        </Grid>
        <Box marginBottom={2}></Box>

        <Grid>
          <GaClickHOC
            category={EVENT_CATEGORIES.RECOVERY_PASSWORD_ORGANISME}
            label="valider"
          >
            <StyledOrangeButton type="submit" variant="contained">
              {loader ? (
                <CircularProgress data-testid="loader" size={20} />
              ) : (
                <React.Fragment>
                  {translate({ ...messages.valid }, props)}
                </React.Fragment>
              )}
            </StyledOrangeButton>
          </GaClickHOC>
        </Grid>
      </Box>
    </form>
  );
};

export interface FormProps {
  intl: IntlShape;
  loader?: boolean;
  onSubmit: Function;
  errorMessage?: string;
}

interface FormValues {
  organization: any;
  drpp: string;
  membershipNumber: string;
  cin: string;
  birthday: string;
}

const FormOrganisme = withFormik<FormProps, FormValues>({
  mapPropsToValues: () => {
    return {
      organization: null,
      drpp: '',
      membershipNumber: '',
      cin: '',
      birthday: '',
    };
  },

  validationSchema,

  handleSubmit: (values, { props }) => {
    props.onSubmit(values);
  },
})(InsertOrganismeIdForm);

export default injectIntl(FormOrganisme);
